import React, { useState } from "react";
import { FaBan } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { addCommasToNumber } from "./definedFunctions";

const TextInputFormik = ({
  formik,
  label,
  field,
  placeholder,
  type = "text",
  required = false,
  customStyles,
  disable = false,
  min,
  style,
  className,
  max = null,
  onChange = false,
  loading = false,
  loadingStyle,
  value,
}) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const postCode = (value) => {
    if (!value) return;
    if (isNaN(value)) return value.slice(0, value.length - 1);
    return value;
  };

  //Adding condition for checkbox and label to hide the error message
  return (
    <div
      className={`mb-1 ${customStyles === "marginBottom0" ? "" : "mb-md-4"} `}
    >
      <label className="fontSize14Medium lineHeight24 text-white mb-1 mb-md-2">
        {label}
        {required && "*"}
      </label>

      <>
        <input
          className={
            type === "checkbox"
              ? className
              : `custom-input fontSize16Regular lineHeight24 input ${style} `
          }
          type={type}
          name={field}
          checked={
            type === "radio"
              ? formik.values[field] === value
              : type === "checkbox"
              ? formik.values[field]
              : undefined
          }
          value={
            value
              ? value
              : type !== "checkbox"
              ? formik?.values?.[field]
              : undefined
          }
          onChange={(e) => {
            if (type === "checkbox") {
              formik.setFieldValue(field, e.target.checked);
            } else if (field === ("postalCode" || "bill_address_zipcode")) {
              const value = postCode(e.target.value);
              formik.setFieldValue(field, value);
            } else if (field === "energyConsumption") {
              // console.log(e.target.value, "e.target.value");
              const formattedValue = e.target.value.replace(/[^0-9 \,.]/, "");

              // const formattedValue = addCommasToNumber(e.target.value);
              formik.setFieldValue(field, formattedValue);
            } else if (field === "bank_data_iban") {
              formik.setFieldTouched(field, e.target.value);
              formik.setFieldValue(field, e.target.value);
            } else {
              formik.setFieldValue(field, e.target.value);
            }
            if (onChange) onChange(e);
          }}
          placeholder={placeholder}
          onFocus={(e) => (e.target.style.borderColor = "#23DC9F")}
          onBlur={(e) => {
            formik.setFieldTouched(field, true, false);
            formik.handleBlur(e); // mark field as touched here
            e.target.style.borderColor = "#23DC9F";
            if (field === "energyConsumption") {
              console.log(e.target.value, "e.target.value");
              const formattedValue = addCommasToNumber(e.target.value);
              formik.setFieldValue(field, formattedValue);
            }
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          min={min}
          maxLength={max}
          disabled={disable}
          style={{
            cursor: disable ? "not-allowed" : "text",
          }}
          onKeyDown={(e) => {
            if (type === "checkbox" && e.key === "Enter") {
              e.preventDefault(); // Prevent any default behavior
              formik.setFieldValue(field, !formik?.values?.[field]);
            }
          }}
        />
        {loading && (
          <div
            className={`spinner-border  ms-2 ${loadingStyle || ""}`}
            role="status"
          ></div>
        )}

        {/* Block icon that appears on hover when feild is disabled */}
        {disable && isHovered && (
          <div className="position-absolute d-flex align-items-center justify-content-center input-diabled-ban-icon">
            <FaBan size={16} />
          </div>
        )}
      </>
      {type !== "checkbox" &&
        type !== "radio" &&
        (formik.submitCount > 0 || formik?.touched?.[field]) &&
        formik?.errors?.[field] && (
          <p className="fontSize14Medium lineHeight1_2 text-pink mt-1 mb-0">
            {t(`${formik.errors[field]}`)}
          </p>
        )}
    </div>
  );
};

export default TextInputFormik;
